import get from 'lodash.get';
import {
    TRO_CONFIRMATION_POPUP,
    FETCH_TRO_BOOK_DATA,
    FETCH_ALL_TRO_BOOKS_DATA,
} from '../actionTypes/reading/apiActionTypes';
import { getConfirmationModalType } from '../../utils/reading/troUtils';
import parseBookData, { parseAllBooksData } from './troParser';

export const initialState = {
    data: {},
    confirmationModalType: null,
    additionalBooksData: {},
    isAdditionalBooksDataFetching: false,
    error: null,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case TRO_CONFIRMATION_POPUP.SHOW:
            return { ...state, confirmationModalType: getConfirmationModalType(action.payload) };
        case TRO_CONFIRMATION_POPUP.CLOSE:
            return { ...state, confirmationModalType: null };
        case FETCH_TRO_BOOK_DATA.SUCCESS:
            return {
                ...state,
                data: { ...state.data, ...parseBookData(action.response) },
            };
        case FETCH_TRO_BOOK_DATA.ERROR:
            return { ...state, error: action.error };
        case FETCH_ALL_TRO_BOOKS_DATA.START:
            return {
                ...state,
                isAdditionalBooksDataFetching: true,
            };
        case FETCH_ALL_TRO_BOOKS_DATA.SUCCESS:
            return {
                ...state,
                isAdditionalBooksDataFetching: false,
                additionalBooksData: parseAllBooksData(action.response),
            };
        case FETCH_ALL_TRO_BOOKS_DATA.ERROR:
            return { ...state, isAdditionalBooksDataFetching: false, error: action.error };
        default:
            return state;
    }
};

const getTroBooksData = state => state.data;

const getTroBookDataById = (state, { selectedBookId }) =>
    get(getTroBooksData(state), selectedBookId);

const showTroConfirmationPopup = state => state.confirmationModalType;

const getAllTroBooksData = state => state.additionalBooksData;

const isAdditionalBooksDataFetching = state => state.isAdditionalBooksDataFetching;

export const selectors = {
    getTroBooksData,
    getTroBookDataById,
    showTroConfirmationPopup,
    isAdditionalBooksDataFetching,
    getAllTroBooksData,
};
